import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import NgwaahiaIcon from "../../../common-components/NgwaahiaIcon";
import {
  NAME_PRONUNCIATION,
  IOS_STORE_URL,
  ANDROID_STORE_URL,
} from "../../../utility/constants";
import { frontendRoutes } from "../../../utility/frontendRoutes";
import { landingColors } from "../landingColors";
import AppScreenshot from "./AppScreenshot";
import SectionContainer from "./SectionContainer";
import LiveCountriesHint from "./LiveCountriesHint";
import JoinedCounter from "./JoinedCounter";
import heroHomefeedIos from "../assets/screenshots/hero-homefeed-ios.webp";

const Hero = () => (
  <SectionContainer sx={{ py: { xs: 8, md: 6 } }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "center", md: "flex-start" },
        gap: { xs: 5, md: 8 },
      }}
    >
      <Box
        sx={{
          flex: 1,
          textAlign: { xs: "center", md: "left" },
          pt: { md: 18 },
        }}
      >
        <Box
          sx={{
            display: "inline-block",
            bgcolor: "transparent",
            border: `1px solid ${landingColors.primary}`,
            color: landingColors.textSecondary,
            borderRadius: 6,
            px: 2.5,
            py: 0.75,
            mb: 1,
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          We're live!
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "center", md: "flex-start" },
            gap: 1.5,
            mb: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              color: landingColors.textPrimary,
              fontSize: { xs: 38, sm: 48, md: 56 },
              letterSpacing: "0.04em",
              lineHeight: 1,
            }}
          >
            Ngwaahia
          </Typography>
          <NgwaahiaIcon size={56} color={landingColors.primary} />
        </Box>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: landingColors.textPrimary,
            fontSize: { xs: 21, sm: 24, md: 28 },
            lineHeight: 1.1,
            mb: 2,
          }}
        >
          Connect. Trade. Thrive.
        </Typography>
        <Typography
          sx={{
            color: landingColors.textSecondary,
            fontSize: { xs: 16, md: 18 },
            maxWidth: 480,
            mx: { xs: "auto", md: 0 },
            mb: 4,
          }}
        >
          Ngwaahia (pronounced {NAME_PRONUNCIATION.respelling}) is an online
          marketplace built for <LiveCountriesHint /> buyers, sellers, and
          service providers. Download the app or browse the marketplace right
          now.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-start" },
            gap: 2,
          }}
        >
          <Button
            component="a"
            href={IOS_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            startIcon={<AppleIcon />}
            sx={{
              bgcolor: landingColors.primary,
              "&:hover": { bgcolor: landingColors.accent },
              borderRadius: 6,
              fontWeight: 700,
              px: 3,
            }}
          >
            App Store
          </Button>
          <Button
            component="a"
            href={ANDROID_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            startIcon={<AndroidIcon />}
            sx={{
              bgcolor: landingColors.primary,
              "&:hover": { bgcolor: landingColors.accent },
              borderRadius: 6,
              fontWeight: 700,
              px: 3,
            }}
          >
            Play Store
          </Button>
          <Button
            component={Link}
            to={frontendRoutes.HOME}
            variant="outlined"
            sx={{
              borderColor: landingColors.primary,
              color: landingColors.primary,
              borderRadius: 6,
              fontWeight: 700,
              px: 3,
            }}
          >
            Browse Marketplace
          </Button>
        </Box>
        <JoinedCounter
          sx={{ mt: 3, textAlign: { xs: "center", md: "left" } }}
        />
      </Box>

      <Box sx={{ flex: 1, maxWidth: 380, width: "100%" }}>
        <AppScreenshot
          src={heroHomefeedIos}
          alt="Ngwaahia app home feed"
          platform="ios"
          variant="phone"
        />
      </Box>
    </Box>
  </SectionContainer>
);

export default Hero;
